import React from 'react';
import { FastFact } from './Overview';
import Grid from '@material-ui/core/Grid';
import colors from '../../../utils/colors';

export interface FastFactProps {
	facts: FastFact[];
}

export const FastFacts: React.FunctionComponent<FastFactProps> = (props: FastFactProps) => {
	const { facts } = props;
	const styles = {
		backgroundColor: colors.lightGrey,
		height: '100%',
	};

	return (
		<Grid container spacing={0} justify="flex-start" className="full-height">
			{facts.map((fact: FastFact, idx: number) => (
				<Grid style={styles} key={idx} item className={fact.Text ? 'grow' : ''}>{fact.Text ? <TextFact text={fact.Text}></TextFact> : <PictureFact image={fact.ImageUrl}></PictureFact>}</Grid>
			))}
		</Grid>
	)
}

export const TextFact: React.FunctionComponent<{ text: string | null }> = (props) => {
	const { text } = props;
	const pattern = /\d{1,4}\skw/i;

	if (!!text) {
		return null;
	}

	return (
		<Grid container justify="center" alignContent="center" className="full-height">
			<p className={`fact-text ${pattern.test(text as string) ? 'first-line' : ''}`}>{text}</p>
		</Grid>
	);
}
export const PictureFact: React.FunctionComponent<{ image: string | null }> = (props) => {
	const { image } = props;

	if (!!image) {
		return null;
	}

	return (
		<img alt="fast facts" className="fact-image" src={image as string} />
	);
}
